/*****************************************************************************
 *
 * Redux store reducer. This is where the store changes are written as the
 * result of the actions dispatched
 *
 *****************************************************************************/

import * as types from './types';

import {COSTS, DISPLAYS, SUMMARIES} from "../utilities/constants";

const reducer = (
  state = {
    loading: false,
    displayType: DISPLAYS.CHART,
    summaryType: SUMMARIES.SUMMARY,
    selectedCost: COSTS.TOTAL,
    selectedStateFips: null,
    comparisonStateFips: null,
    selectedCountyFips: null,
    comparisonCountyFips: null,
    nationalData: [],
    statesData: [],
    countiesData: []
  },
  action
) => {
  switch (action.type) {

    case types.SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading
      };

    case types.SET_DISPLAY_TYPE:
      return {
        ...state,
        displayType: action.payload.displayType
      };

    case types.SET_SUMMARY_TYPE:
      return {
        ...state,
        summaryType: action.payload.summaryType
      };

    case types.SET_SELECTED_COST:
      return {
        ...state,
        selectedCost: action.payload.selectedCost
      };

    case types.SET_SELECTED_STATE_FIPS:
      // Nullify value if they match (deselect)
      if (state.selectedStateFips === action.payload.selectedStateFips) {
        return {
          ...state,
          selectedStateFips: null,
        }
      }

      return {
        ...state,
        selectedStateFips: action.payload.selectedStateFips
      };

    case types.SET_COMPARISON_STATE_FIPS:
      // Nullify value if they match (deselect)
      if (state.comparisonStateFips === action.payload.comparisonStateFips) {
        return {
          ...state,
          comparisonStateFips: null,
        }
      }

      return {
        ...state,
        comparisonStateFips: action.payload.comparisonStateFips
      };

    case types.SET_SELECTED_COUNTY_FIPS:
      // Nullify value if they match (deselect)
      if (state.selectedCountyFips === action.payload.selectedCountyFips) {
        return {
          ...state,
          selectedCountyFips: null,
        }
      }

      return {
        ...state,
        selectedCountyFips: action.payload.selectedCountyFips
      };

    case types.SET_COMPARISON_COUNTY_FIPS:
      // Nullify value if they match (deselect)
      if (state.comparisonCountyFips === action.payload.comparisonCountyFips) {
        return {
          ...state,
          comparisonCountyFips: null,
        }
      }

      return {
        ...state,
        comparisonCountyFips: action.payload.comparisonCountyFips
      };

    case types.SET_NATIONAL_DATA:
      return {
        ...state,
        nationalData: action.payload.nationalData
      };

    case types.SET_STATES_DATA:
      return {
        ...state,
        statesData: action.payload.statesData
      };

    case types.SET_COUNTIES_DATA:
      return {
        ...state,
        countiesData: action.payload.countiesData
      };

    default:
      return state;
  }

};

export default reducer;
